var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-tick-flash',{attrs:{"value":_vm.params.value}},[_vm._v("\n  "+_vm._s(_vm.params.valueFormatted)),_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.$t('white-label.globalLabels.buttonAria')))])])}
var staticRenderFns = []

export { render, staticRenderFns }